export enum ChatStatus {
  ONBOARDING = 'onboarding',
  CHAT = 'chat',
}

export enum ChatModalType {
  PATIENT = 'patient',
  CONSENT = 'consent',
  END = 'end',
  NONE = 'none',
}

export enum ChatMode {
  NONE = 'none',
  TIPS = 'tips',
}

export enum ChatMessageFeedback {
  THUMBS_DOWN = 'thumbsDown',
  THUMBS_UP = 'thumbsUp',
}

export type ChatMessageFeedbackState = Partial<
  Record<ChatMessageFeedback, boolean>
>;

export type ChatMessageRole = 'assistant' | 'human';

export interface ChatMessage {
  id: string;
  role: ChatMessageRole;
  text: string;
  createdAt: string;
  data?: Record<string, any>;
}

export interface SuggestionResponse {
  id: string;
  text: string;
  selected?: string;
}

export interface PatientConfirmationDetails {
  appointmentDoctorName: string;
  appointmentGpPractice: string;
  appointmentDate: string;
  appointmentTime: string;
}

export interface EndChatExportOptions {
  email: boolean;
  download: boolean;
  print: boolean;
}
